import { Table } from "antd";
import { OrderSummary } from "../../../../models/Order";
import { Link } from "react-router-dom";
import { Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface OrderTableProps {
  orders: OrderSummary[];
  pageSize: number;
  OrderCount: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const OrderTable = (props: OrderTableProps) => {
  const columns = [
    {
      title: "",
      key: "idx",
      render: (item: OrderSummary) => item.idx,
    },
    {
      title: "Client",
      key: "client",
      render: (item: OrderSummary) => item.client_code,
    },
    {
      title: "Nro Pedido",
      key: "order_numbers",
      render: (item: OrderSummary) =>
        item.order_numbers && item.order_numbers.length > 0
          ? item.order_numbers.join(", ")
          : "-",
    },
    {
      title: "Start",
      key: "start",
      render: (item: OrderSummary) => item.timestamp_start,
    },
    {
      title: "End",
      key: "end",
      render: (item: OrderSummary) => item.timestamp_end,
    },
    {
      title: "Equipment",
      key: "equipment",
      render: (item: OrderSummary) => item.equipment_code,
    },
    {
      title: "Status",
      key: "status",
      render: (item: OrderSummary) => item.status,
    },
    {
      title: "Web",
      key: "web",
      render: (item: OrderSummary) => (
        <Link to={"../p/" + item.assembly_code}>
          <Button type="primary" icon={<InfoCircleOutlined />} shape="round">
            {"Details"}
          </Button>
        </Link>
      ),
    },
  ];

  const paginationConfig = {
    pageSize: props.pageSize,
    total: props.OrderCount,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50"],
    onChange: (page: number, pageSize: number | undefined) => {
      if (pageSize) {
        props.onPageChange(page, pageSize);
      }
    },
  };

  return (
    <Table
      columns={columns}
      dataSource={props.orders}
      rowKey="id"
      scroll={{ x: true }}
      size="small"
      pagination={paginationConfig}
    />
  );
};

export default OrderTable;
